import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { configure } from "mobx";

import React from "react";

import { App } from "./App";
import reportWebVitals from "./reportWebVitals";

configure({
  enforceActions: "never",
});

const publicUrl = typeof process.env.PUBLIC_URL === "string" ? process.env.PUBLIC_URL : "";
const routerBasename = publicUrl.length > 0 && publicUrl !== "/"
  ? publicUrl.replace(/\/$/, "")
  : undefined;

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
    min-height: 100%;
    overflow-y: hidden;
    display: flex;
    flex-grow: 1;
  }

  * {
    box-sizing: border-box;
  }
`;

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Momento fan client: #root element not found.");
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename}>
      <GlobalStyle />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  rootEl,
);

reportWebVitals();
